import React, { useEffect, useState } from 'react'
import styles from './AdviceModal.module.css'
import Button from '../../material/button/Button'

function Header(props) {
    let text = props.text || ''
    let number = props.number || null

    return (
        <div className={styles.headerContainer}>
            {number ? <div className={styles.number}>{number}</div> : null}
            <div className={styles.text}>{text}</div>
        </div>
    )
}

function AdviceModal(props) {

    const [pageIndex, setPageIndex] = useState(0)

    const backButton = () => {
        if (pageIndex > 0) {
            setPageIndex(pageIndex - 1)
        }
    }
    const nextButton = () => {
        if (pageIndex < 3) {
            setPageIndex(pageIndex + 1)
        }
    }

    useEffect(() => {
        setPageIndex(0)
    }, [props.show])

    const getTextHeader = (index) => {
        if (index === 0) {
            return 'คำแนะนำสำหรับการสมัครใช้งานและการเข้าสู่ระบบ'
        } else if (index === 1) {
            return 'เข้าใช้งานด้วย Digital ID'
        } else if (index === 2) {
            return 'เข้าใช้งานด้วยชื่อผู้ใช้งาน'
        } else if (index === 3) {
            return 'เข้าใช้งานด้วยหมอพร้อม'
        } else {
            return '-'
        }
    }
    return (
        <>
            {props.show ?
                <div className={styles.overlay}>
                    <div className={styles.modalContainer}>
                        <div className={styles.closeButtonContainer}>
                            <img onClick={props.onClose} src={require('../../../asset/icon/close-icon.svg').default}></img>
                        </div>
                        <div>
                            <Header text={getTextHeader(pageIndex)} number={pageIndex} />
                        </div>
                        <div className={styles.imageContainer}>
                            {/* {pageIndex === 0 ? <img src={require('../../../asset/image/advice0.svg').default}></img> : null}
                                {pageIndex === 1 ? <img src={require('../../../asset/image/advice1.svg').default}></img> : null}
                                {pageIndex === 2 ? <img src={require('../../../asset/image/advice2.svg').default}></img> : null}
                                {pageIndex === 3 ? <img src={require('../../../asset/image/advice3.svg').default}></img> : null} */}
                            <div className={styles.imageSlide}
                                style={{
                                    marginLeft: '-' + pageIndex * 100 + '%'
                                }}
                            >
                                <div className={styles.image}>
                                    <img src="/images/advice0.svg"></img>
                                </div>
                                <div className={styles.image}>
                                    <img src="/images/advice1.svg"></img>
                                </div>
                                <div className={styles.image}>
                                    <img src="/images/advice2.svg"></img>
                                </div>
                                <div className={styles.image}>
                                    <img src="/images/advice3.svg"></img>
                                </div>
                            </div>
                        </div>
                        <div className={styles.buttonContainer}>
                            {pageIndex !== 0 ? <Button onClick={backButton} style={{ width: 130, background: "#fff" }}>ย้อนกลับ</Button> : null}
                            {pageIndex !== 3 ? <Button onClick={nextButton} style={{ width: 130 }}>ถัดไป</Button> : null}
                        </div>
                    </div>
                </div>
                :
                null
            }
        </>

    )
}

export default AdviceModal